<template>
<div>
    <div v-if="loaded">
        <!-- PROFESSIONS -->
        <v-row class="mt-1" v-if="user.mytop.professions">
            <v-col cols="12" sm="4" md="3">
                <Title class="mt-3" text="PROFESSIONS"/>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div id="professionsP1">
                    <Contacter
                        :num="1"
                        :title="user.mytop.professions.p1"
                        :model="model.professions.p1"
                        :close="close"
                        labeltit="Company"
                        division="professions"
                        @save="save"
                        @go="go('professionsP1')"
                        v-if="user.mytop.professions.p1" />
                </div>
                
                <div id="professionsP2">
                    <Contacter
                        :num="2"
                        :title="user.mytop.professions.p2"
                        :model="model.professions.p2"
                        :close="close"
                        labeltit="Company"
                        division="professions"
                        @save="save"
                        @go="go('professionsP2')"
                        v-if="user.mytop.professions.p2" />
                </div>

                <div id="professionsP3">
                    <Contacter
                        :num="3"
                        :title="user.mytop.professions.p3"
                        :model="model.professions.p3"
                        :close="close"
                        labeltit="Company"
                        division="professions"
                        @save="save"
                        @go="go('professionsP3')"
                        v-if="user.mytop.professions.p3" />
                </div>
            </v-col>
        </v-row>

        <v-divider class="mt-2"></v-divider>

        <!-- MAJORS -->
        <v-row class="mt-1" v-if="user.mytop.majors">
            <v-col cols="12" sm="4" md="3">
                <Title class="mt-3" text="MAJORS"/>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div id="majorsP1">
                    <Contacter
                        :num="1"
                        :title="user.mytop.majors.p1"
                        :model="model.majors.p1"
                        :close="close"
                        labeltit="Company"
                        division="majors"
                        @save="save"
                        @go="go('majorsP1')"
                        v-if="user.mytop.majors.p1" />
                </div>
                
                <div id="majorsP2">
                    <Contacter
                        :num="2"
                        :title="user.mytop.majors.p2"
                        :model="model.majors.p2"
                        :close="close"
                        labeltit="Company"
                        division="majors"
                        @save="save"
                        @go="go('majorsP2')"
                        v-if="user.mytop.majors.p2" />
                </div>

                <div id="majorsP3">
                    <Contacter
                        :num="3"
                        :title="user.mytop.majors.p3"
                        :model="model.majors.p3"
                        :close="close"
                        labeltit="Company"
                        division="majors"
                        @save="save"
                        @go="go('majorsP3')"
                        v-if="user.mytop.majors.p3" />
                </div>
            </v-col>
        </v-row>

        <v-divider class="mt-2"></v-divider>

        <!-- UNIVERSITIES -->
        <v-row class="mt-1" v-if="user.mytop.universities">
            <v-col cols="12" sm="4" md="3">
                <Title class="mt-3" text="UNIVERSITIES"/>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div id="universitiesP1">
                    <Contacter
                        :num="1"
                        :title="user.mytop.universities.p1.name"
                        :model="model.universities.p1"
                        :close="close"
                        labeltit="University"
                        division="universities"
                        @save="save"
                        @go="go('universitiesP1')"
                        v-if="user.mytop.universities.p1" />
                </div>
                
                <div id="universitiesP2">
                    <Contacter
                        :num="2"
                        :title="user.mytop.universities.p2.name"
                        :model="model.universities.p2"
                        :close="close"
                        labeltit="University"
                        division="universities"
                        @save="save"
                        @go="go('universitiesP2')"
                        v-if="user.mytop.universities.p2" />
                </div>

                <div id="universitiesP3">
                    <Contacter
                        :num="3"
                        :title="user.mytop.universities.p3.name"
                        :model="model.universities.p3"
                        :close="close"
                        labeltit="University"
                        division="universities"
                        @save="save"
                        @go="go('universitiesP3')"
                        v-if="user.mytop.universities.p3" />
                </div>
            </v-col>
        </v-row>

        <v-divider class="mt-2"></v-divider>

        <!-- COMPANIES -->
        <v-row class="mt-1" v-if="user.mytop">
            <v-col cols="12" sm="4" md="3">
                <Title class="mt-3" text="COMPANIES"/>
            </v-col>
            <v-col cols="12" sm="8" md="9">
                <div id="companiesP1">
                    <Contacter
                        :num="1"
                        :title="user.mytop.companies.p1"
                        :model="model.companies.p1"
                        :close="close"
                        labeltit="Company"
                        division="companies"
                        @save="save"
                        @go="go('companiesP1')"
                        v-if="user.mytop.companies.p1" />
                </div>
                
                <div id="companiesP2">
                    <Contacter
                        :num="2"
                        :title="user.mytop.companies.p2"
                        :model="model.companies.p2"
                        :close="close"
                        labeltit="Company"
                        division="companies"
                        @save="save"
                        @go="go('companiesP2')"
                        v-if="user.mytop.companies.p2" />
                </div>

                <div id="companiesP3">
                    <Contacter
                        :num="3"
                        :title="user.mytop.companies.p3"
                        :model="model.companies.p3"
                        :close="close"
                        labeltit="Company"
                        division="companies"
                        @save="save"
                        @go="go('companiesP3')"
                        v-if="user.mytop.companies.p3" />
                </div>
            </v-col>
        </v-row>
    </div>

    <div class="text-center my-12" v-if="notMytop">
        <div>In order to complete this section, first you have to complete your Top 3.</div>
        <v-btn depressed large class="accent mt-8 mb-12" @click="$router.push('/my-top3')">go to my Top 3</v-btn>
    </div>
</div>
</template>

<script>
import _ from 'lodash'
import Sign from '@/firebase/sign'
import Title from '@/components/planner/Title'
import Contacter from '@/components/planner/Contacter'
import Personal from '@/firebase/personal'

export default {
    data: () => ({
        loaded: false,
        factoralia: false,
        sending:false,
        close: false,
        notMytop: false,
        model: {
            professions: {
                p1: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
                p2: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
                p3: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
            },
            majors: {
                p1: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
                p2: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
                p3: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
            },
            universities: {
                p1: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
                p2: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
                p3: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
            },
            companies: {
                p1: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
                p2: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
                p3: { c1:{name: '', org: ''}, c2:{name: '', org: ''}, c3:{name: '', org: ''}, c4:{name: '', org: ''}, c5:{name: '', org: ''} },
            }
        },
        optionsScroll: {
            duration: 800,
            offset: 0,
            easing: 'easeInOutCubic'
        }
    }),
    components: {
        Title,
        Contacter
    },
    mounted() {
        if (this.user.mytop) {
            if (this.user.planner) {
                this.model = _.merge(this.model, this.user.planner);
            }
            this.loaded = true;
        } else {
            this.notMytop = true;
        }
        
    },
    methods: {
        go(str) {
            this.$vuetify.goTo('#'+str, this.optionsScroll)
        },
        save(e) {
            this.model[e.division]['p'+e.pointer] = e.content;

            Personal.updatePlanner(this.user.uid, this.model)
                    .then(response => {
                        if (response === true) {
                            this.close = !this.close;
                            Sign.reInitUser(this.user.uid);
                            this.$store.dispatch('setSnack', {kind:'success', text:'My Reputation Planner has been updated.'});
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'Error.'});
                        }
                        this.sending = false;
                    });
        }
    }
}
</script>